

export enum STATUS_DATA {
    ACTIVE = "active",
    INACTIVE = "inactive"
}